/* eslint-disable */
var $ = window.jQuery = require('jquery');
export default {
  name: 'admin-sidebar',
  components: {},
  props: [],
  data() {
    return {
      i: '',
      isRoleIn:'',
      isRoleAssess:'',
      isRoleAssessPart:'',
      isRoleAssessDashboard:false,
      isRoleAssessCourses:false,
      isRoleAssessCategories:false,
      isRoleAssessUsers:false,
      isRoleAssessPayment:false,
      isRoleAssessPublic:false,
      isRoleAssessAuthor:false,
      isRoleAssessContest:false,
      collapseIconState:false
    }
  },
  computed: {
    getUserDetails() {
      this.$store.dispatch('getUserRoleDetails').then((res) => {
        this.isRoleIn = res.data.data.profile.role,
        this.isRoleAssess = res.data.data.profile.author_tabs
        this.isRoleAssessPart = this.isRoleAssess.split(',')
        for (var i = 0; i < this.isRoleAssessPart.length; i++) {
          let RoleAccess_Val = this.isRoleAssessPart[i]
          if(RoleAccess_Val === 'courses'){
            this.isRoleAssessCourses = true
          }else if(RoleAccess_Val === 'public_quiz') {
            this.isRoleAssessPublic = true
          }else if(RoleAccess_Val === 'contest_quiz') {
            this.isRoleAssessContest = true
          }
        }
      }).catch((err) => {})
    },
  },
  mounted() {
    this.getUserDetails
    $(document).ready(function() {
      $('.toggleSidebar').on('click', function() {
        if ($(window).width() < 981) {
          $('.admin-sidebar, .admin-dashboard, body').removeClass('show');
          $('header .mobilemenu-icon').removeClass('open');
        }
      })
    })
  },
  methods: {
    sideCollaspeMethod(){
      if(this.collapseIconState == true){
        document.querySelector('.admin-dashboard').classList.remove('actvCollaspe');
        this.collapseIconState = false
      }else{
        this.collapseIconState = true
        document.querySelector('.admin-dashboard').classList.add('actvCollaspe');
      }
    }

  },
}